<template>
  <div>
    <v-container       
      class="full-height"
      fluid
    >
      <v-card>
        <v-card-title>Payroll Expenditure Report</v-card-title>
        <v-row class="px-4">
          <v-col
            cols="8"
            class="pt-0"
          >
            <v-data-table 
              v-model="selectedEmployees"
              v-validate="'required'"
              dense
              :loading="loading"
              :error-messages="errors.collect('selectedEmployees')"
              data-vv-name="selectedEmployees"
              data-vv-as="employees"
              :headers="headers"
              :items="filteredEmployees"
              hide-default-footer
              fixed-header
              disable-pagination
              show-select
              item-key="employee_uid"
              item-value="employee_uid"
              class="elevation-2 mb-3"
              height="420px"
            >
              <template v-slot:top>
                <h5 class="font-weight-bold py-2 mb-0 pl-2">
                  Employee Selection:
                </h5>
              </template> 
              <template v-slot:item.ic_number="{ item }">
                {{ ((item.person || {}).identity_card || {}).ic_number ? ((item.person || {}).identity_card || {}).ic_number : ((item.person || {}).identity_card || {}).passport_number }}
              </template> 
            </v-data-table>
            <span class="red--text text--lighten-1 caption">{{ errors.first('selectedEmployees') }}</span>

            <v-row class="pl-4">
              <v-col>
                <span>Employee Status</span>
                <v-radio-group
                  v-model="isActive"
                  class="mt-0"
                  row
                >
                  <v-radio
                    label="Active"
                    :value="1"
                  />
                  <v-radio
                    label="Inactive"
                    :value="0"
                  /> 
                  <v-radio
                    label="All"
                    :value="2"
                  />
                </v-radio-group>
              </v-col>
            </v-row>
          </v-col>

          <v-col
            cols="4"
            class="pt-0"
          >
            <v-text-field
              v-model="searchInput"
              placeholder="Filter employee by name"
              append-icon="search"
              label="Search Employee"
              hide-no-data
              hide-selected
            />

            <v-autocomplete
              v-model="selectedGroups"
              :items="groupOptions"
              item-text="text"
              item-value="value"
              label="Company Group"
              placeholder="Filter company by group"
              clearable
              hide-selected
              multiple
              small-chips
              deletable-chips
              chips
            />

            <v-autocomplete
              v-model="selectedCompanies"
              :items="companyOptions"
              item-text="name"
              item-value="id"
              label="Company"
              placeholder="Filter employee by company"
              clearable
              hide-selected
              multiple
              small-chips
              deletable-chips
              chips
            />

            <v-autocomplete
              v-model="selectedCostCenters"
              :items="filteredCostCentersByCompany"
              item-text="name"
              item-value="id"
              label="Cost Center"
              placeholder="Filter employee by cost center"
              clearable
              hide-selected
              multiple
              small-chips
              deletable-chips
              chips
            />

            <v-autocomplete
              v-model="selectedPositions"
              :items="positions"
              item-text="label"
              item-value="id"
              label="Position"
              placeholder="Filter employee by position"
              clearable
              hide-selected
              multiple
              small-chips
              deletable-chips
              chips
            />

            <v-autocomplete
              v-model="selectedDepartments"
              :items="departments"
              item-text="name"
              item-value="id"
              label="Department"
              placeholder="Filter employee by department"
              clearable
              hide-selected
              multiple
              deletable-chips
              small-chips
              chips
            />

            <v-menu
              v-model="startMonthMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="startMonthDisplay"
                  v-validate="'required'"
                  :error-messages="errors.collect('startMonthDisplay')" 
                  data-vv-name="startMonthDisplay"
                  label="From Payroll Period"
                  readonly
                  data-vv-as="start month"  
                  class="label-position"   
                  :class="{
                    'required':!startMonthDisplay
                  }"
                  v-on="on"
                >
                  <template v-slot:prepend-inner>
                    <v-icon>
                      mdi-calendar
                    </v-icon>
                  </template>
                </v-text-field>
              </template>
              <v-date-picker
                v-model="fromPayrollPeriod"
                type="month"
                :allowed-dates="allowedMonths"
                @input="startMonthMenu = false;"
                @change="loadEmployees()"
              />
            </v-menu>

            <v-menu
              v-model="endMonthMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="endMonthDisplay"
                  v-validate="'required'"
                  :disabled="!fromPayrollPeriod"
                  :error-messages="errors.collect('endMonthDisplay')" 
                  data-vv-name="endMonthDisplay"
                  label="To Payroll Period"
                  readonly
                  data-vv-as="end month"  
                  class="label-position"   
                  :class="{
                    'required':!endMonthDisplay
                  }"
                  v-on="on"
                >
                  <template v-slot:prepend-inner>
                    <v-icon>
                      mdi-calendar
                    </v-icon>
                  </template>
                </v-text-field>
              </template>
              <v-date-picker
                v-model="toPayrollPeriod"
                type="month"
                :min="fromPayrollPeriod"
                :allowed-dates="allowedMonths"
                @input="endMonthMenu = false;"
                @change="loadEmployees()"
              />
            </v-menu>

            <v-card-actions>
              <v-spacer />
              <v-btn
                block
                :loading="progressing"
                color="hrissecondary"     
                class="white--text"     
                @click="generate"
              >
                Generate
              </v-btn>
            </v-card-actions>
          </v-col>
        </v-row>  
      </v-card>
    </v-container>  
  </div>      
</template>
<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      positions: {
        type: Array,
        required: true,
      },
      departments: {
        type: Array,
        required: true,
      },
      companies: {
        type: Array,
        required: true,
      },
      costCenters: {
        type: Array,
        required: true,
      },
      payrollPeriods: {
        type: Array,
        required: true,
      },
    },
    data () {
      return {
        loading: false,
        progressing: false,
        searchInput: '',
        selectedGroups: [],
        selectedCompanies: [],
        selectedPositions: [],
        selectedDepartments: [],
        selectedCostCenters: [],
        selectedEmployees: [],
        headers: [
          {
            text: 'Name',
            align: 'left',
            sortable: true,
            value: 'person.name',
          },
          {
            text: 'IC',
            align: 'left',
            sortable: true,
            value: 'ic_number',
          },
          {
            text: 'Department',
            align: 'left',
            sortable: true,
            value: 'department.name',
          },
          {
            text: 'Position',
            align: 'left',
            sortable: true,
            value: 'current_position.position.name',
          }, 
          {
            text: 'Resigned Date',
            align: 'left',
            sortable: true,
            value: 'end_date',
          },       
        ],
        fromPayrollPeriod: null,
        toPayrollPeriod: null,
        startMonthMenu: false,
        endMonthMenu: false,
        isActive: 1,
        employees: [],
      }
    },
    computed: {
      groupOptions () {
        if (!this.companies) return []
        const groups = new Set()

        this.companies.forEach(company => {
          const groupVal = company.organization_lookup_uid
          if (!groupVal) return

          groups.add(company.group)
        })

        return Array.from(groups).map(group => ({
          text: `${(group || {}).value} Group`,
          value: group.lookup_uid,
        }))
      },
      filteredEmployees () {
        let _this = this
        _this.searchInput = _this.searchInput.trim()
        let primaryFilterEmployees = this.employees.filter(function (employee) {
          return ((employee.person || {}).name || '').toLowerCase().indexOf(_this.searchInput.toLowerCase()) !== -1 
        })

        const endDate = this.$moment(this.toPayrollPeriod).format('YYYY-MM-DD')

        let secondaryFilterEmployees = primaryFilterEmployees.filter(function (employee) {
          if (_this.isActive === 1) {
            return (!employee.end_date || employee.end_date > endDate)
          } else if (_this.isActive === 0) {
            return (employee.end_date && employee.end_date <= endDate)
          } else {
            return ((!employee.end_date || employee.end_date > endDate) || (employee.end_date && employee.end_date <= endDate))
          }
        })

        let filteredGroups = this.customFilterCompanyGroups(secondaryFilterEmployees)
        let filteredCompanies = this.customFilterCompanies(filteredGroups)
        let filteredCostCenters = this.customFilterCostCenters(filteredCompanies)
        let filteredPositions = this.customFilterPositions(filteredCostCenters)
        let filteredDepartments = this.customFilterDepartments(filteredPositions)
        return filteredDepartments
      },
      allowedMonths () {
        const payrollMonths = this.payrollPeriods.map((period) =>
          period.payroll_date.slice(0, 7)
        )

        return (date) => payrollMonths.includes(date.slice(0, 7))
      },
      startMonthDisplay () {
        return this.fromPayrollPeriod ? this.$moment(this.fromPayrollPeriod, 'YYYY-MM-DD').format('MMM YYYY') : ''
      },
      endMonthDisplay () {
        return this.toPayrollPeriod ? this.$moment(this.toPayrollPeriod, 'YYYY-MM-DD').format('MMM YYYY') : ''
      },
      filteredPayrollPeriods () {
        if (!this.fromPayrollPeriod || !this.toPayrollPeriod) return []

        const startDate = new Date(this.fromPayrollPeriod)
        const endDate = new Date(this.toPayrollPeriod)

        return this.payrollPeriods
          .filter((period) => {
            const payrollDate = new Date(period.payroll_date)
            return payrollDate >= startDate && payrollDate <= endDate
          }).map(period => period.id)
      },
      sortedPeriods () {
        return [...this.payrollPeriods].sort(
          (a, b) => new Date(a.payroll_date) - new Date(b.payroll_date)
        )
      },
      currentYearPeriods () {
        const currentYear = new Date().getFullYear()

        return this.sortedPeriods.filter(p =>
          new Date(p.payroll_date).getFullYear() === currentYear
        )
      },
      filteredCostCentersByCompany () {
        const selectedCompanies = this.selectedCompanies || []

        return this.costCenters.filter(cc => {
          if (selectedCompanies.length === 0) return true

          return selectedCompanies.includes(cc.selected_company_uid)
        })
      },
      filteredCompanies () {
        if (!this.selectedGroups.length) return this.companies

        return (this.companies || []).filter(company =>
          this.selectedGroups.includes(company.organization_lookup_uid)
        )
      },
      companyOptions () {
        const companies = (this.filteredCompanies || []).map(company => ({
          name: company.name,
          id: company.id,
        }))

        return [
          { name: 'All Companies', id: 'ALL' },
          ...companies,
        ]
      },
    },
    watch: {
      filteredEmployees (newList) {
        this.$validator.pause()

        const newEmployeeUids = new Set(newList.map(emp => emp.employee_uid))

        this.selectedEmployees = this.selectedEmployees.filter(selectedEmp =>
          newEmployeeUids.has(selectedEmp.employee_uid)
        )

        this.$nextTick(() => {
          this.$validator.resume()
        })
      },
      payrollPeriods: {
        immediate: true,
        handler () {
          if (this.currentYearPeriods.length > 0) {
            this.fromPayrollPeriod = this.currentYearPeriods[0].payroll_date.slice(0, 7)

            this.toPayrollPeriod = this.currentYearPeriods[this.currentYearPeriods.length - 1].payroll_date.slice(0, 7)
          }
        },
      },
      selectedGroups () {
        const validIds = (this.filteredCompanies || []).map(company => company.id)

        if (this.selectedCompanies.includes('ALL')) {
          this.selectedCompanies = [...validIds]
        } else {
          this.selectedCompanies = this.selectedCompanies.filter(id =>
            validIds.includes(id)
          )
        }
      },
      selectedCompanies (newVal) {
        const last = newVal[newVal.length - 1]
        
        // If last selected is 'ALL', keep only 'ALL'
        if (last === 'ALL' && newVal.length > 1) {
          // Replace with only 'ALL' after current update cycle
          this.$nextTick(() => {
            this.selectedCompanies = ['ALL']
          })
        } else if (newVal.includes('ALL') && newVal.length > 1) {
          // Remove 'ALL' if other company is selected after it
          this.$nextTick(() => {
            this.selectedCompanies = newVal.filter(id => id !== 'ALL')
          })
        }
      },
    },
    created () {
      this.loadEmployees()
    },
    methods: {
      loadEmployees () {
        if (this.filteredPayrollPeriods.length > 0) {
          this.loading = true

          this.$api.employees().list('?payrollPeriodIds=[' + this.filteredPayrollPeriods + ']')
            .then(response => {
              let temp = response.data.filter(employee => {
                return employee.department_id !== null
              })

              this.employees = _.orderBy(temp, ['person.name'], ['asc'])
              this.loading = false
            })
            .catch(() => {})
        }
      },
      prepareFormData () {
        return {
          payrollPeriodIds: this.filteredPayrollPeriods,
          employeeUids: this.getEmployeeUids(),
          companyIds: this.selectedCompanies.includes('ALL') ? (
            this.filteredCompanies.filter(company => {
              return company.id !== 'ALL'
            }).map(company => {
              return company.id
            })
          ) : this.selectedCompanies,
          costCenterIds: this.selectedCostCenters,
          positionIds: this.selectedPositions,
          departmentIds: this.selectedDepartments,
        }
      },
      generate () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.payrollReports().yearlyPayrollExpenditureReport(this.prepareFormData())
              .then(res => {
                let blob = new Blob([res.data], { type: res.data.type })
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.setAttribute('download', 'Payroll Expenditure Report - ' + this.$moment(this.fromPayrollPeriod).format('MMM YYYY') + ' to ' + this.$moment(this.toPayrollPeriod).format('MMM YYYY') + ' [' + this.$moment().format('YYYY-MM-DD h.mma') + '].xlsx')
                link.click()

                this.progressing = false
                this.$snack({ message: 'Report downloaded successfully' })
              })
              .catch(() => {
                this.progressing = false
                this.$snack({
                  color: 'error',
                  message: 'Failed to generate report. Please contact IT support',
                })
              })
          })
      },

      getEmployeeUids () {
        let employeeUids = []

        this.selectedEmployees.map(item => {
          employeeUids.push(item.employee_uid)
        })

        return employeeUids
      },

      customFilterCompanyGroups (employeesList) {
        if (this.selectedGroups.length === 0) return employeesList

        const startDate = this.$moment(this.fromPayrollPeriod).format('YYYY-MM-DD')
        const endDate = this.$moment(this.toPayrollPeriod).format('YYYY-MM-DD')

        return employeesList.filter(employee => {
          if (employee.company_employees.length <= 0) return 

          let companyEmployees = employee.company_employees.filter(ce => {
            return ce.start_date <= endDate && 
              (!ce.end_date || ce.end_date >= startDate)
          })

          if (companyEmployees.length > 0) {
            let organizationLookupUids = companyEmployees.map(
              ce => ce.company.organization_lookup_uid
            )
  
            return _.intersection(organizationLookupUids, this.selectedGroups).length > 0
          }
        })
      },

      customFilterCompanies (employeesList) {
        if (this.selectedCompanies.length === 0) return employeesList

        if (this.selectedCompanies.includes('ALL')) {
          const validIds = (this.filteredCompanies || []).map(company => company.id)

          this.selectedCompanies = [...validIds]
        }

        const startDate = this.$moment(this.fromPayrollPeriod).format('YYYY-MM-DD')
        const endDate = this.$moment(this.toPayrollPeriod).format('YYYY-MM-DD')

        return employeesList.filter(employee => {
          if (employee.company_employees.length <= 0) return 

          let companyEmployees = employee.company_employees.filter(ce => {
            return ce.start_date <= endDate && 
              (!ce.end_date || ce.end_date >= startDate)
          })

          if (companyEmployees.length > 0) {
            let activeCompanyUids = companyEmployees.map(
              ce => ce.company_uid
            )
  
            return _.intersection(activeCompanyUids, this.selectedCompanies).length > 0
          }
        })
      },

      customFilterCostCenters (employeesList) {
        const selected = this.selectedCostCenters

        if (!selected.length) {
          return employeesList
        }

        const startDate = this.$moment(this.fromPayrollPeriod).format('YYYY-MM-DD')
        const endDate = this.$moment(this.toPayrollPeriod).format('YYYY-MM-DD')
        const selectedSet = new Set(selected)

        return employeesList.filter(employee => {
          const activeCompanies = employee.company_employees.filter(ce =>
            ce.start_date <= endDate &&
            (!ce.end_date || ce.end_date >= startDate)
          )

          if (!activeCompanies.length) {
            return false
          }

          return activeCompanies.some(ce => {
            if (ce.latest_cost_center) {
              let costCenterId = ce.latest_cost_center.cost_center_id
              return costCenterId && selectedSet.has(costCenterId)
            }
          })
        })
      },

      customFilterPositions (employeesList) {
        if (this.selectedPositions.length === 0) return employeesList

        return employeesList.filter(employee => {
          let positionId = (employee.current_position || {}).position_id
  
          return _.intersection([positionId], this.selectedPositions).length > 0
        })
      },

      customFilterDepartments (employeesList) {
        if (this.selectedDepartments.length === 0) return employeesList

        return employeesList.filter(employee => {
          return _.intersection([employee.department_id], this.selectedDepartments).length > 0
        })
      },
    },       
  }
</script>
